<template>
  <v-dialog v-model="value" fullscreen>

    <v-card>
      <v-toolbar class="flex-grow-0 flex-shrink-1">
        <v-app-bar-nav-icon v-if="promo.image" class="mx-2">
          <v-img :src="promo.image"
                 eager
                 contain
                 height="40"
          ></v-img>
        </v-app-bar-nav-icon>

        <v-toolbar-title class="font-weight-bold">
          {{ promo.name }}
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <v-btn @click="close" color="primary" fab small>
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>



      <v-card-text :style="{position: 'relative'}" class="py-6 " >
      <div v-if="$vuetify.breakpoint.smAndUp"
           :style="{position: 'absolute', top: '3px', right: '10px'}">
        <gallery-view-buttons></gallery-view-buttons>
      </div>

        <v-row
            v-for="config in promo.config"
            :key="config.category.id"
            :id="config.category.name"
        >

          <v-col cols="12">
            <h5 class="text-h4 grey--text text--darken-4 font-weight-bold">
              {{ config.category.name }}
              ({{ orderPromo.getQuantityByCategory(config.category) }}/{{ config.quantity }})
              <v-chip class="mb-1" color="green white--text" v-if="orderPromo.hasReachMaxCategory(config.category)">
                Listo
              </v-chip>
            </h5>
            <v-divider></v-divider>
          </v-col>

          <v-col v-for="product in config.products"
                 :key="product.id"
                 cols="12" :sm="$store.getters.galleryView"
          >

            <promo-product-card
                :product="product"
                :category="config.category"
                :order="1"
                :quantity="getItemQuantity(product, config.category)"
                :stock-quantity="getStockProductQuantity(product.id)"
                edit-quantity
                @addItem="addItem(product, config.category)"
                @removeItem="removeItem(product, config.category)"
            />

          </v-col>

        </v-row>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">Cancelar</v-btn>
        <v-btn color="primary" @click="addOrderPromo">Agregar Promo</v-btn>
      </v-card-actions>

    </v-card>

    <v-snackbar v-model="snackbar" :timeout="4000" color="orange darken-2"  bottom>
      <span class="title">{{ snackbarText }}</span>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import PromoProductCard
  from "@/modules/delivery/components-core/shared/PromoProductCard/PromoProductCard.vue";
import StockMixin from "@/modules/delivery/mixins/StockMixin";
import GalleryViewButtons from "@/modules/delivery/components-core/shared/GalleryViewButtons/GalleryViewButtons.vue";

export default {
  name: "PromoDialog",
  components: {GalleryViewButtons, PromoProductCard},
  mixins: [StockMixin],
  props: {
    value: {type: Boolean, default: false},
    promo: {type: Object, required: true},
    stock: {type: Object, required: true},
  },
  created() {
    this.orderPromo = this.$store.getters.orderSystem.createOrderPromo(this.promo)
  },
  data() {
    return {
      orderPromo: null,
      snackbar: false,
      snackbarText: ''
    }
  },
  computed: {
    getItemQuantity() {
      return (product, category) => {
        if (this.orderPromo) {
          return this.orderPromo.getQuantityByCategoryAndProduct(product, category)
        } else {
          return 0
        }
      }
    },
    isComplete() {
      return this.orderPromo.isComplete()
    }
  },
  methods: {
    close() {
      this.$emit('input', false)
    },
    addItem(product, category, order) {
      return this.orderPromo.addPromoItem(product, category, order)
    },
    removeItem(product, category) {
      return this.orderPromo.removePromoItem(product, category)
    },
    addOrderPromo() {
      if (this.orderPromo.isComplete()) {
        this.$store.getters.orderSystem.addOrderPromo(this.orderPromo)
        this.close()
      } else {
        this.snackbarText = 'La promo no esta completa'
        this.snackbar = true
      }

    }
  }
}
</script>

<style scoped>

</style>
